"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import { useTranslations } from "next-intl";
import { useAuth } from "@/lib/auth";

// Rutas accesibles sin sesión.
const PUBLICAS = ["/login"];

/** Sin sesión, todo menos /login redirige al login (conservando a dónde se quería ir). */
export function AuthGate({ children }: { children: React.ReactNode }) {
  const t = useTranslations("common");
  const { user, loading } = useAuth();
  const pathname = usePathname();
  const router = useRouter();
  const publica = PUBLICAS.includes(pathname);

  useEffect(() => {
    if (loading || user || publica) return;
    const next = pathname && pathname !== "/" ? `?next=${encodeURIComponent(pathname)}` : "";
    router.replace(`/login${next}`);
  }, [loading, user, publica, pathname, router]);

  if (publica) return <>{children}</>;
  if (loading || !user) return <div className="p-8 text-muted-foreground">{t("cargando")}</div>;
  return <>{children}</>;
}
